import React from 'react';

const Zoom: React.FC = () => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
>
    <g clip-path="url(#clip0_38_1809)">
        <path
            d="M16.5244 7.99908C16.5244 7.99908 13.5244 2.49908 8.52441 2.49908C3.52441 2.49908 0.524414 7.99908 0.524414 7.99908C0.524414 7.99908 3.52441 13.4991 8.52441 13.4991C13.5244 13.4991 16.5244 7.99908 16.5244 7.99908ZM1.69741 7.99908C2.18093 7.26421 2.73705 6.57977 3.35741 5.95608C4.64441 4.66708 6.40441 3.49908 8.52441 3.49908C10.6444 3.49908 12.4034 4.66708 13.6924 5.95608C14.3128 6.57977 14.8689 7.26421 15.3524 7.99908C15.2944 8.08608 15.2304 8.18208 15.1574 8.28708C14.8224 8.76708 14.3274 9.40708 13.6924 10.0421C12.4034 11.3311 10.6434 12.4991 8.52441 12.4991C6.40441 12.4991 4.64541 11.3311 3.35641 10.0421C2.73606 9.41839 2.18093 8.73396 1.69741 7.99908Z"
            fill="white"
        />
        <path
            d="M8.52441 5.49908C7.86137 5.49908 7.22549 5.76248 6.75665 6.23132C6.28781 6.70016 6.02441 7.33604 6.02441 7.99908C6.02441 8.66213 6.28781 9.29801 6.75665 9.76685C7.22549 10.2357 7.86137 10.4991 8.52441 10.4991C9.18746 10.4991 9.82334 10.2357 10.2922 9.76685C10.761 9.29801 11.0244 8.66213 11.0244 7.99908C11.0244 7.33604 10.761 6.70016 10.2922 6.23132C9.82334 5.76248 9.18746 5.49908 8.52441 5.49908ZM5.02441 7.99908C5.02441 7.07083 5.39316 6.18059 6.04954 5.52421C6.70592 4.86783 7.59616 4.49908 8.52441 4.49908C9.45267 4.49908 10.3429 4.86783 10.9993 5.52421C11.6557 6.18059 12.0244 7.07083 12.0244 7.99908C12.0244 8.92734 11.6557 9.81758 10.9993 10.474C10.3429 11.1303 9.45267 11.4991 8.52441 11.4991C7.59616 11.4991 6.70592 11.1303 6.04954 10.474C5.39316 9.81758 5.02441 8.92734 5.02441 7.99908Z"
            fill="white"
        />
    </g>
    <defs>
        <clipPath id="clip0_38_1809">
            <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(0.524658 -0.00012207)"
            />
        </clipPath>
    </defs>
</svg>
);

export default Zoom;
